import { notification } from "antd";
import { ZEE_CLIENT } from "constants/phase";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import Image from "../../../components/common/Image/component";
import { CloseModal } from "../../../components/icons";

const PublishThumbNailModal = (props) => {
  const {
    handlePublishThumbnailModal,
    openPublishThumbnailModal,
    publishThumbnailClip,
    publishZeeThumbnails,
    thumbnails,
    clientSetting,
  } = props;
  const [selectedThumbnails, setSelectedThumbnails] = useState([]);

  const handleSelectedThumbnails = (thumbnail) => {
    let thumbnails = [...selectedThumbnails];
    const index = thumbnails.findIndex((url) => url === thumbnail);
    if (index !== -1) {
      // thumbnail present
      thumbnails.splice(index, 1);
    } else {
      thumbnails.push(thumbnail);
    }
    setSelectedThumbnails(thumbnails);
  };

  const publishThumbnails = async () => {
    const payload = {
      clipId: publishThumbnailClip?._id,
      streamId: publishThumbnailClip?.streamId,
      publishZeeThumbnails: selectedThumbnails,
      updateVideoThumbnail: clientSetting?.clientType === ZEE_CLIENT ? true : false,
    };
    const { value } = await publishZeeThumbnails(payload);
    if (value?.success) {
      notification["success"]({ message: "Publish Initated Successfully" });
    } else {
      notification["error"]({ message: "Something went wrong!" });
    }
    handlePublishThumbnailModal();
  };

  useEffect(() => {
    if (publishThumbnailClip?.publishedCustomThumbnailUrls) {
      setSelectedThumbnails(publishThumbnailClip?.publishedCustomThumbnailUrls);
    }
  }, [publishThumbnailClip]);

  return (
    <div>
      <Modal
        isOpen={openPublishThumbnailModal}
        ariaHideApp={false}
        onRequestClose={handlePublishThumbnailModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xl modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Choose Thumbnail</h5>
            <button type="button" onClick={handlePublishThumbnailModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <div className="react-modal-body">
            <div className="inner-container content-control-block styled-scroll">
              <ul className="choose-thumbnail-grid aspect-ratio-thumb">
                {thumbnails?.length > 0 &&
                  thumbnails?.map((clipThumb, index) => {
                    return (
                      <>
                        <li
                          onClick={() => handleSelectedThumbnails(clipThumb)}
                          className={selectedThumbnails.includes(clipThumb) ? "thumb-select" : ""}
                          key={index}
                        >
                          <div className="img-container-ratio">
                            <Image src={clipThumb} alt="VideoOS" name="thumburl" />
                          </div>
                          {selectedThumbnails.indexOf(clipThumb) !== -1 ? (
                            <div class="vv-video-clip-tags title_Pascal">
                              <span class="ant-tag">{selectedThumbnails.indexOf(clipThumb) + 1}</span>
                            </div>
                          ) : null}
                          <span className="slected-thumb-text">Selected</span>
                        </li>
                      </>
                    );
                  })}
              </ul>
            </div>
          </div>
          <div className="react-modal-footer row m-0">
            <div className="col-lg-6 text-center text-lg-end">
              <button type="button" className="btn btn-white" onClick={handlePublishThumbnailModal}>
                Cancel
              </button>
              <button type="button" className="btn btn-primary" onClick={publishThumbnails}>
                Save
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PublishThumbNailModal;
